import React, { useState, useEffect } from 'react';
import MainLoader from 'src/assets/loader/main_loading_img.gif';
import { i18nService } from 'src/services/i18n.service';

export interface LoginDefaultSpinnerProps {
  loadingMessage?: string;
}

/**
 * Default animated spinner for the login page
 */
const LoginDefaultSpinner = ({ loadingMessage }: LoginDefaultSpinnerProps) => {
  return (
    <div className="loader-container">
      <div className="loader-container-inner">
        <div className="text-center">
          <img src={MainLoader} alt="loader" className="loader-size" />
        </div>
        <h6 className="loading-spinner-text">
          {loadingMessage ?? i18nService.translate('loadingMessage1')}
        </h6>
      </div>
    </div>
  );
};

export default LoginDefaultSpinner;
